import React from 'react';
import PropTypes from 'prop-types';

import OrderTableItem from '../TableItem';

export const CheckoutOrderTableList = ({
    orderProducts,
    orderCurrencySymbol,
    changeItemQuantity,
    removeItem,
    readOnly,
}) => (
    <div>
        {orderProducts.map((product) => (
            <OrderTableItem
                changeItemQuantity={(quantity) => changeItemQuantity(product, quantity)}
                removeItem={() => removeItem(product)}
                readOnly={readOnly}
                duration={product.minimum_term_months}
                orderCurrencySymbol={orderCurrencySymbol}
                product={product}
                single={orderProducts.length === 1}
                key={product.id}
            />
        ))}
    </div>
);

CheckoutOrderTableList.propTypes = {
    orderProducts: PropTypes.arrayOf(PropTypes.object).isRequired,
    orderCurrencySymbol: PropTypes.string.isRequired,
    changeItemQuantity: PropTypes.func,
    removeItem: PropTypes.func,
    readOnly: PropTypes.node,
};

CheckoutOrderTableList.defaultProps = {
    changeItemQuantity: () => {},
    removeItem: () => {},
    readOnly: undefined,
};

export default CheckoutOrderTableList;
